import { hanwahaInstance } from '../../../shared_elements';
const qbProvider = hanwahaInstance ? 'hanwha-qb' : 'quickbooks';

export const getProductService = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/integrations/${qbProvider}/auth-url/${queryString ? `?${queryString}` : ''}`;
};

export const getProductServiceList = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `/integrations/${qbProvider}/products-services/${queryString ? `?${queryString}` : ''}`;
};

export const getProductServiceCompanyNamesApi = () => {
   return `integrations/${qbProvider}/company_name/?source=product_and_service`;
}